import { Settings2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  DepotGridPanel,
  depotTableClassName,
  depotTableHeadClassName,
  depotTdClassName,
  depotThClassName,
} from './depot-grid';

const setupRows = [
  { area: 'Depot Sites & Yard Slots', purpose: 'Depot, block, bay, row, tier, slot capacity', owner: 'Ops Admin', mode: 'Inline grid' },
  { area: 'Activity Charge Codes', purpose: 'Gate, storage, lift, repair, wash, admin fees', owner: 'Finance', mode: 'Inline grid' },
  { area: 'Rate / Cost Source', purpose: 'Customer tariff, default list price, activity cost source', owner: 'Commercial', mode: 'Batch editable' },
  { area: 'Lifecycle Status Rules', purpose: 'Booking, gate, EIR, repair, hold, release, billing stages', owner: 'Ops Admin', mode: 'Controlled list' },
  { area: 'External Access Policy', purpose: 'Customer self-service menu, WhatsApp approval, share link expiry', owner: 'Admin', mode: 'Grant table' },
];

export default function DepotSetupPage() {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold">Setup</h2>
          <p className="text-sm text-muted-foreground">
            Master data and rules are managed as compact editable lists. No card-based maintenance.
          </p>
        </div>
        <Button size="sm"><Settings2 className="mr-2 h-4 w-4" />New Setup Row</Button>
      </div>

      <DepotGridPanel title="Depot Configuration Workbench" subtitle="Each setup area opens as a dense editable table with import/export and audit trail.">
        <table className={depotTableClassName}>
          <thead className={depotTableHeadClassName}>
            <tr>
              <th className={depotThClassName}>Area</th>
              <th className={depotThClassName}>Purpose</th>
              <th className={depotThClassName}>Owner</th>
              <th className={depotThClassName}>Edit Mode</th>
              <th className={depotThClassName}>Status</th>
            </tr>
          </thead>
          <tbody>
            {setupRows.map((row) => (
              <tr key={row.area} className="border-b last:border-0 hover:bg-muted/20">
                <td className={`${depotTdClassName} font-medium`}>{row.area}</td>
                <td className={depotTdClassName}>{row.purpose}</td>
                <td className={depotTdClassName}>{row.owner}</td>
                <td className={depotTdClassName}>{row.mode}</td>
                <td className={depotTdClassName}><Badge variant="secondary">Configured</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </DepotGridPanel>
    </div>
  );
}
